export default {"src":"/_next/static/media/3-quarter-pounder-field.0b012a5d.gif","height":370,"width":700};